import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBPS010InitRequest } from 'types/MCBPS010/MCBPS010InitRequest'
import { MCBPS010InitializeDisplayInfoDto } from 'types/MCBPS010/MCBPS010InitializeDisplayInfoDto'
import { MCBPS010CreateRequest } from 'types/MCBPS010/MCBPS010CreateRequest'
import { MCBPS010UpdateTargetDataInfoDto } from 'types/MCBPS010/MCBPS010UpdateTargetDataInfoDto'
import { MCBPS010CreateDisplayInfoDto } from 'types/MCBPS010/MCBPS010CreateDisplayInfoDto'

interface SelectionFileUpdateData {
  initializeDisplayInfo: MCBPS010InitializeDisplayInfoDto
  openFlg: boolean
  updateTargetDataInfo: MCBPS010UpdateTargetDataInfoDto
  createDisplayInfo: MCBPS010CreateDisplayInfoDto
  againComfigFlg: boolean
}

const initialState: SelectionFileUpdateData = {
  initializeDisplayInfo: {
    selectionFileNameInfoList: [],
    jobSeekerId: 0,
    jobSeekerByCompanyId: 0
  },
  openFlg: false,
  updateTargetDataInfo: {
    jobSeekerSelectionFileId: '',
    jobSeekerByCompanyId: ''
  },
  createDisplayInfo: {
    messageInfo: '',
    updateTargetDataInfo: {
      jobSeekerSelectionFileId: '',
      jobSeekerByCompanyId: ''
    }
  },
  againComfigFlg: false,
}
const selectionFileUploadReducer = createSlice({
  name: 'selectionFileUpload',
  initialState,
  reducers: {
    selectionFileUploadInit(state, action: PayloadAction<MCBPS010InitRequest>) {
      return state
    },
    setSelectionFileUploadInit(state, action: PayloadAction<MCBPS010InitializeDisplayInfoDto>) {
      state.initializeDisplayInfo = action.payload
      state.openFlg = true
    },
    setSelectionFileUploadOpenFlg(state) {
      state.openFlg = false
    },
    selectionFileUploadInsert(state, action: PayloadAction<MCBPS010CreateRequest>) {
      return state
    },
    setUpdateTargetDataInfo(state, action: PayloadAction<MCBPS010CreateDisplayInfoDto>) {
      state.createDisplayInfo = action.payload
    },
    setUpdateAgainComfigFlg(state, action:PayloadAction<boolean>) {
      state.againComfigFlg = action.payload
    },
    setCreateDisplayInfoMessageEmpty(state) {
      state.createDisplayInfo.messageInfo = ''
    },
  },
})

export const {
  selectionFileUploadInit,
  setSelectionFileUploadInit,
  setSelectionFileUploadOpenFlg,
  selectionFileUploadInsert,
  setUpdateTargetDataInfo,
  setUpdateAgainComfigFlg,
  setCreateDisplayInfoMessageEmpty,
} = selectionFileUploadReducer.actions

export default selectionFileUploadReducer.reducer